/** Below this shortest screen side a touch device is a phone, not a tablet. */
const PHONE_SHORT_SIDE_PX = 600;

export type PhoneProbe = {
  matchMedia?: (query: string) => { matches: boolean } | undefined;
  screen?: { width: number; height: number };
};

/**
 * A phone is a touch device whose shortest screen side is under 600 px. The
 * physical screen is used rather than the window so rotating the phone does
 * not change the answer; tablets (iPad, Galaxy Tab) keep the editor.
 */
export const isPhone = (
  probe: PhoneProbe = typeof window === "undefined"
    ? {}
    : { matchMedia: window.matchMedia?.bind(window), screen: window.screen },
): boolean => {
  const coarse = probe.matchMedia?.("(pointer: coarse)")?.matches ?? false;
  if (!coarse || !probe.screen) {
    return false;
  }
  return (
    Math.min(probe.screen.width, probe.screen.height) < PHONE_SHORT_SIDE_PX
  );
};
